import React from 'react';
import {VstInput, VstButton} from 'vstui';

// Renders the User Decision Screen
class DecisionContainer extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      email: props.email ? decodeURIComponent(props.email) : '',
      emailFailure: false
    };

    this._checkSigninForm = this._checkSigninForm.bind(this);
    this._checkEmailSubmit = this._checkEmailSubmit.bind(this);
    this._resetEmail = this._resetEmail.bind(this);
    this._onEmailChange = this._onEmailChange.bind(this);
    this._onPasswordChange = this._onPasswordChange.bind(this);
    this._skipSSO = this._skipSSO.bind(this);
    this._renderBookCover = this._renderBookCover.bind(this);

    this.loginFailureRef = React.createRef();
  }

  componentDidMount(){
    $(".account-graphic").find("img").on("load", this.props.redraw);
  }

  componentDidUpdate(){
    // TODO :: Maybe we can bring this up a level?
    Fraction.Helpers.bindLinks();
  }

  _checkSigninForm(){
    var checkemail = document.forms["signin-form"]["user[email]"].value;
    var checkpassword = document.forms["signin-form"]["user[password]"].value;
    return this.props.isValidEmail(checkemail) ||
          checkpassword === null ||
          checkpassword === "";
  }

  _checkEmailSubmit(e){
    e.preventDefault();
    if (!this.props.isValidEmail(this.state.email)) {
      this.setState({emailFailure: true});
    } else {
      this.setState({ emailFailure: false });
      if (this.state.setEmail){
        this.props.mergeAccount({email: this.state.setEmail, password: this.state.password});
      } else {
        // check if email exists
        Jigsaw.User.exists(this.state.email, (response) => {
          if (response.isSuccess()){
            if (response.data.exists){
              this.setState({ setEmail: this.state.email, password: "" });
            } else {
              this.props.setRegistrationEmail(this.state.email);
            }
          }
        });
      }
    }
    return false;
  }

  _resetEmail(e) {
    this.setState({email: "", setEmail: false});
  }

  _onEmailChange(e) {
    this.setState({email: e.currentTarget.value});
  }

  _onPasswordChange(e) {
    this.setState({password: e.currentTarget.value});
  }

  _skipSSO() {
    Fraction.Helpers.ssoSkipped = true;
    Fraction.Helpers.redirectMe();
    Fraction.Reporter.gaEvent("sso/skip-for-now");
  }

  _renderBookCover(bookCover) {
    return (
      <div className="account-graphic">
        <img src={`${Fraction.Environment.coversHost}/vbid/${bookCover}/width/200`} />
      </div>
    );
  }

  render() {
    var redirect = document.location.protocol+"//"+document.location.host+document.location.search;
    if (redirect[redirect.length-1]==="/"){
      redirect.substring(0, redirect.length-1);
    }

    var failure = document.location.protocol+"//"+document.location.host+"/#/user/signin/failure/"+encodeURIComponent(this.state.email);
    if (Fraction.redirectAfterSignIn){
      redirect+="/#/"+Fraction.Helpers.redirectUrl();
    }

    var loginFailure = this.state.emailFailure ? i18n.t('signin.invalid-email') : this.props.signinerror ? i18n.t('signin.failure') : null;
    var bookCover = false; bookCover = Fraction.lastISBN;
    if (Fraction.redirectAfterSignIn && Fraction.redirectAfterSignIn[0]==="books"){
      bookCover = Fraction.redirectAfterSignIn[1];
    }
    return (
      <div>
        <div onScroll={this.props.redraw}>
          { Fraction.Helpers.modalToShow }

          <div className={"account decision-container"+(bookCover ? " book-cover" : "")}>

            {bookCover ? this._renderBookCover(bookCover) : this.props.renderAccountGraphic()}

            <div className="account-content decision">
              <h1>
                {window.toHTML(i18n.t('signin.signin-welcome').decodeHTML())}
              </h1>
              {!this.state.setEmail ?
                <div className="description"></div> :
                <div className="description">{i18n.t('sso.email-exists')}</div>
              }

              <form noValidate onSubmit={this._checkEmailSubmit} id="signin-form" method="post">
                <div className={"email-field"+(this.state.setEmail ? " set-email" : "")}>
                  {this.state.setEmail ?
                    <div className="decision-set-email">{this.state.setEmail} <span><button className="noButton" onClick={this._resetEmail}>{i18n.t('registration.change-email')}</button></span></div>
                    :
                    <VstInput id="email-field"
                              label={toHTML(i18n.t('registration.to-begin'))}
                              failure={loginFailure}
                              type="email"
                              name="user[email]"
                              options="large"
                              onBlur={this._}
                              placeholder={i18n.t('base.email')}
                              value={this.state.email}
                              onChange={this._onEmailChange} />
                  }
                </div>
                {this.state.setEmail &&
                  <VstInput id="password-input"
                            label={i18n.t('base.password')}
                            failure={loginFailure}
                            type="password"
                            name="user[password]"
                            placeholder={i18n.t('base.password')}
                            onChange={this._onPasswordChange}
                            value={this.state.password} />
                }
                <input type="hidden" name="return" id="login-return" value={redirect} />
                <input type="hidden" name="failure" id="login-return" ref={this.loginFailureRef} value={failure} />
                <VstInput type="submit"
                          id="submit"
                          label="submit"
                          options="btn-44 block"
                          value={i18n.t('base.continue')} />
                {(this.state.setEmail && Fraction.Brand.ForgotPassword.enabled) &&
                  <a className="forgot-password" href="/user/forgot">{i18n.t('signin.forgot-password')}</a>
                }
              </form>

              {!this.state.setEmail && Fraction.Brand.AccountCompletion.showBenefits &&
                <span>
                  <div className="benefits-description">
                    <div className="full-account-description description">{i18n.t('sso.account-benefits')}</div>
                    <div className="benefits">
                      <div className="full-account-benefit">
                        <div>
                          <div className="icon"><img src="/img/sso_devices.svg" /></div>
                          <div>{i18n.t('sso.read-offline')}</div>
                        </div>
                      </div>
                      <div className="full-account-benefit">
                        <div>
                          <div className="icon"><img src="/img/sso_sharing.svg" /></div>
                          <div>{i18n.t('sso.share-highlighters')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="clear" />
                  {!Fraction.Brand.AccountCompletion.force &&
                    <VstButton id="skip-sso-button"
                      options="btn-36 neutral block"
                      onClick={this._skipSSO}>{i18n.t('sso.skip-option')}
                    </VstButton>
                  }
                </span>
              }

            </div>
          </div>
        </div>
      </div>
    );
  }

};

export default DecisionContainer;
